import React, { useEffect, useState } from "react";
import { getBranchOrders, getBranchOrdersByBranch, getBranches } from "../../function/branch";
import OrderPopup from "./OrderPopup";
import { Pagination } from "antd"; // ✅ ใช้ Pagination ของ antd

import axios from "axios";

const BranchOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [userRole, setUserRole] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(5);

  const [editingOrder, setEditingOrder] = useState(null);
  const [newReceiptDate, setNewReceiptDate] = useState("");

  useEffect(() => {
    loadUserRole();
    loadBranches();
    loadOrders();
  }, []);

  const loadUserRole = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.role) {
        setUserRole(user.role);
        if (user.role === "staff") {
          setSelectedBranch(user.branch?._id || "");
        }
      }
    } catch (error) {
      console.error("Error fetching user role:", error);
    }
  };

  const loadOrders = async (branchId = "") => {
    try {
      setLoading(true);
      const authtoken = localStorage.getItem("token");
      let res;

      if (branchId) {
        res = await getBranchOrdersByBranch(authtoken, branchId);
      } else {
        res = await getBranchOrders(authtoken);
      }

      setOrders(res.data);
    } catch (error) {
      console.error("Error fetching orders:", error);
      if (error.response && error.response.status === 401) {
        alert("คุณไม่มีสิทธิ์ดูออเดอร์ของสาขานี้");
      }
    } finally {
      setLoading(false);
    }
  };

  const loadBranches = async () => {
    try {
      const authtoken = localStorage.getItem("token");
      const { data } = await getBranches(authtoken);
      setBranches(data);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const handleBranchChange = (e) => {
    const branchId = e.target.value;

    if (userRole === "staff") {
      alert("คุณไม่มีสิทธิ์เลือกสาขา");
      return;
    }
    console.log("Selected Branch ID:", branchId);
    setSelectedBranch(branchId);
    loadOrders(branchId);
  };

  const handleEditDate = (order) => {
    setEditingOrder(order);
    setNewReceiptDate(order.receiptDate ? new Date(order.receiptDate).toISOString().split("T")[0] : "");
  };

  const handleUpdateDate = async (orderId) => {
    try {
      const authtoken = localStorage.getItem("token");
      const res = await axios.put(
        `${process.env.REACT_APP_API}/branch-order/${orderId}`,
        { receiptDate: newReceiptDate },
        {
          headers: { authtoken },
        }
      );
      alert("อัปเดตวันที่สำเร็จ!");
      setEditingOrder(null);
      loadOrders(); // โหลดคำสั่งซื้อใหม่
    } catch (error) {
      console.error("Error updating receipt date:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดตวันที่");
    }
  };
  // ตัดออเดอร์เฉพาะหน้าปัจจุบัน
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

  return (
    <div className="container mx-auto p-4 mt-5">
      <h2
        className="font-bold mb-4" // ยังคงใช้ className สำหรับการจัดการอื่น ๆ
        style={{ fontSize: "22px", }} // ปรับขนาดตัวอักษรและสี
      >
        รายการคำสั่งซื้อสาขา
      </h2>

      {/* Dropdown เลือกสาขา */}
      <div className="mb-4">
        <label className="mr-2 font-semibold">เลือกสาขา:</label>
        <select
          value={selectedBranch}
          onChange={handleBranchChange}
          className="border px-4 py-2 rounded"
          disabled={userRole === "staff"}
        >
          <option value="">ทั้งหมด</option>
          {branches.map((branch) => (
            <option key={branch._id} value={branch._id}>
              {branch.name}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <p>กำลังโหลดข้อมูล...</p>
      ) : (
        <>
          <table className="min-w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2">หมายเลขออเดอร์</th>
                <th className="border px-4 py-2">สาขา</th>
                {/* <th className="border px-4 py-2">สถานะ</th> */}
                <th className="border px-4 py-2">ผู้ทำรายการ</th>
                <th className="border px-4 py-2">วันที่</th>
                <th className="border px-4 py-2">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {currentOrders.length > 0 ? (
                currentOrders.map((order) => (
                  <tr key={order._id} className="text-center">
                    <td className="border px-4 py-2">{order.orderNumber}</td>
                    <td className="border px-4 py-2">{order.branch?.name || "-"}</td>
                    {/* <td className="border px-4 py-2">{order.orderStatus}</td> */}
                    <td className="border px-4 py-2">{order.createdBy?.name || "-"}</td>
                    <td className="border px-4 py-2 text-left">
                      <div className="flex justify-between items-center">
                        {/* วันที่ */}
                        <span className="w-40">
                          {order.receiptDate
                            ? new Date(order.receiptDate).toLocaleDateString("th-TH", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })
                            : "-"}
                        </span>

                        {/* ปุ่มแก้ไข */}

                      </div>
                    </td>
                    <td className="border px-4 py-2 text-center">
                      {/* <button
                        onClick={() => setSelectedOrder(order)}
                        className="px-4 py-2 rounded bg-gray-700 text-white hover:bg-gray-800 transition duration-200"
                      >
                        ดูรายละเอียด
                      </button> */}
                      <button
                        onClick={() => setSelectedOrder(order)}
                        style={{ backgroundColor: "#6c757d", color: "white", border: "1px solid ", }} // สีเขียว
                        className="px-4 py-2 rounded"
                      >
                        ดูรายละเอียด
                      </button>
                      <button
                        onClick={() => handleEditDate(order)}
                        style={{
                          backgroundColor: "#fff", // สีเดียวกับปุ่มดูรายละเอียด
                          color: "#6c757d",
                          border: "1px solid #fff",
                          marginLeft: "8px", // เพิ่มระยะห่างระหว่างปุ่ม
                          fontSize: "14px",
                          padding: "6px 16px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                        className="rounded"
                        title="แก้ไขวันที่"
                      >
                        ✏️ (แก้ไข)
                      </button>
                    </td>

                    {/* <td className="border px-4 py-2">
                      <button
                        onClick={() => handleEditDate(order)}
                        className="px-4 py-2 rounded bg-blue-500 text-white"
                      >
                        แก้ไขวันที่
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-4">ไม่มีคำสั่งซื้อ</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* ✅ ใช้ Pagination ของ Ant Design */}
          <div className="flex justify-center mt-4">
            <Pagination
              current={currentPage}
              pageSize={ordersPerPage}
              total={orders.length}
              onChange={(page) => setCurrentPage(page)}
            />
          </div>
        </>
      )}
      {editingOrder && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-lg">
            <h2 className="text-lg font-bold mb-4">แก้ไขวันที่ออกใบเสร็จ</h2>
            <input
              type="date"
              className="border px-4 py-2 rounded w-full mb-4"
              value={newReceiptDate}
              onChange={(e) => setNewReceiptDate(e.target.value)}
            />
            <div className="flex justify-end">
              <button
                onClick={() => setEditingOrder(null)}
                className="px-4 py-2 rounded mr-2"
                style={{
                  backgroundColor: "#d61919", // สีพื้นหลังปุ่ม
                  color: "white", // สีตัวอักษร
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                ยกเลิก
              </button>
              <button
                onClick={() => handleUpdateDate(editingOrder._id)}
                className="px-4 py-2 rounded"
                style={{
                  backgroundColor: "#43bc43", // สีพื้นหลังปุ่ม
                  color: "white", // สีตัวอักษร
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                บันทึก
              </button>
            </div>
          </div>
        </div>
      )}
      {/* แสดง Popup เมื่อเลือกออเดอร์ */}
      {selectedOrder && <OrderPopup order={selectedOrder} onClose={() => setSelectedOrder(null)} />}
    </div>
  );
};

export default BranchOrderList;
